<template>
	<div>
		<v-alert type="info" :value="true" class="text-xs-left">
			<strong>Exciting new automated billing system! No more manual invoices</strong>
			<div>Simply select your plan below to get started</div>
		</v-alert>
	</div>
</template>

<script>
	export default {
		name: 'ProductPlanIntro'
	};
</script>
